import type { MetaDescriptor } from '@remix-run/react';
import { parseURL } from '@archipro-website/top-navigation';
import { NON_FILTER_KEYS } from './no-index-product-category';
import { getLocation } from '~/modules/search/util/filter-url-helpers';
import { getCountryCodeByName } from '~/modules/location/util';
import type { SupportedCountry } from '@archipro-website/top-navigation/generated/graphql';
import { noIndexNoFollow } from '@modules/seo/util/no-index-no-follow';

/**
 * Index page for no filter or one location filter professional category pages
 * @param metaDescriptors
 * @param URL
 * @returns
 */
export const noIndexProfessionalCategory = (
    metaDescriptors: MetaDescriptor[],
    url: string,
): MetaDescriptor[] => {
    if (!url.startsWith('/professionals')) return metaDescriptors;

    const { indexPage } = isLocationIndexPage(url);

    return noIndexNoFollow(true, true, indexPage, metaDescriptors);
};

export const isLocationIndexPage = (
    url: string,
): { indexPage: boolean; country: SupportedCountry | null } => {
    const { params } = parseURL(url);
    const filterKeys = Object.keys(params).filter(
        (key) => !NON_FILTER_KEYS.includes(key),
    );
    const location = getLocation(params);
    const country = getCountryCodeByName(location?.country);
    const indexPage =
        !filterKeys.length ||
        (filterKeys.length === 1 && filterKeys[0] === 'location');
    return { indexPage: !!indexPage, country };
};
